'use strict';
/* global noUiSlider */
/* global wNumb */

var util = require('../util');
var currentValues,
	defaultPriceValues,
	defaultCocoaValues = '0%100%',
	prevPriceValues,
	prevCocoaValues,
	URLQueries,
	priceSliderStep = window.SitePreferences.PRICE_SLIDER_STEP,
	cocoaSliderStep = window.SitePreferences.COCOA_SLIDER_STEP;

/*
 * @disc Prepare data for price refinement, pass data to renderSlider that builds slider
 * @see renderSlider
 */
function initPriceRefinements () {

	var pmin = $('#price-refinement-link').data('minprice'),
		pmax = $('#price-refinement-link').data('maxprice'),
		priceUISlider = document.getElementById('price-refinement-slider'),
		maxPrice = $('#price-refinement-link').data('maxrange');

	defaultPriceValues = window.Resources.CURRENCY_SYMBOL + 0 + window.Resources.CURRENCY_SYMBOL + $('#price-refinement-link').data('maxrange');

	if (!priceUISlider || !maxPrice) {
        return;
	}

	prevPriceValues = window.Resources.CURRENCY_SYMBOL + pmin + window.Resources.CURRENCY_SYMBOL + pmax;
	renderSlider(priceUISlider, {
			startOption:[pmin, pmax],
			step:priceSliderStep,
			range: {
				'min': 0,
				'max': maxPrice
			},
			format: {
				decimals: 0,
				prefix: window.Resources.CURRENCY_SYMBOL
			}
	}, function () {
		$('#price-refinement-slider').removeClass('loading');
		$('.price-refinement').addClass('active');
	});

}
/*
 * @disc Prepare data for cocoa refinement, pass data to renderSlider, that builds slider
 * @see renderSlider
 */
function initCocoaRefinements () {
	var cmin, cmax,
		cocoaUISlider = document.getElementById('cocoa-refinement-slider');

	if (!cocoaUISlider) {
        return;
	}

	if (!URLQueries || URLQueries.indexOf('cmax') === -1) {
		cmin = 0;
		cmax = 100;
	} else {
		cmin = URLQueries.match(/cmin=(\d+)/)[1];
		cmax = URLQueries.match(/cmax=(\d+)/)[1];
	}
	prevCocoaValues = cmin + '%' + cmax + '%';
	renderSlider(cocoaUISlider, {
			startOption:[cmin, cmax],
			step:cocoaSliderStep,
			range: {
				'min': 0,
				'max': 100
			},
			format: {
				decimals: 0,
				postfix: '%'
			}
	}, function () {
		$('#cocoa-refinement-slider').removeClass('loading');
	});
}
/*
 * @desc Draw slider on frontend based on received arguments
 */
function renderSlider (el, options, callback) {

	noUiSlider.create(el, {
		start: options.startOption,
		step: options.step,
		margin: options.step,
		connect:true,
		tooltips: true,
		range: options.range,
		format: wNumb(options.format)
	});

	setTimeout(callback, 40);
	el.noUiSlider.on('set', initSliderEventHandler);
}
/*
 * @desc Invoked after interaction with slider refinement has been completed, so data needs to be applied.
 * Build and URL with refinement values and mimic default refinement selection
 */
function applyRefinementsRange (min, max, link) {
	var MinReg = new RegExp(min + '=\\d+'),
		MaxReg = new RegExp(max + '=\\d+'),
		defaultReg = new RegExp('(\\?|\\&)' + min + '=\\d+\\&' + max + '=\\d+'),
		isDefault,
		minValue = currentValues[0].match(/\d+/g).join(''),
		maxValue = currentValues[1].match(/\d+/g).join(''),
		params = {}, //for query free URL
		minParam, maxParam, //for existing values;
		newURL,
		currentValuesCopy = currentValues.join('');

	isDefault = currentValuesCopy === defaultPriceValues || currentValuesCopy === defaultCocoaValues ? true : false;

	if (!URLQueries || URLQueries.indexOf(min) === -1) {
		params[min] = minValue;
		params[max] = maxValue;
		newURL = !isDefault ? util.appendParamsToUrl(location.href, params) : location.href;

	} else {
		minParam = !isDefault ? min + '=' + minValue : '';
		maxParam = !isDefault ? max + '=' + maxValue : '';

		newURL = URLQueries.replace(MinReg, minParam);
		newURL = newURL.replace(MaxReg, maxParam);
		newURL = '?' + newURL;

		if (isDefault) {
			newURL = location.href.replace(defaultReg, '');
			if (newURL.indexOf('&') !== -1 && newURL.indexOf('?') === -1) {
				newURL = newURL.replace('&', '?');
			}
		}
	}

	link.attr('href', newURL);
	link.trigger('click');
}
/*
 * @desc Run once default interaction with the one of the slider buttons took place
 * check if initSliderEventHandler hasn't been called again within 300ms by comparing
 * outer and inner variables && check if given values aren't the same as was used for previous refinement
 */
function initSliderEventHandler (givenValues) {
	currentValues = givenValues;
	setTimeout(function () {
		var cv = currentValues.join(''), gv = givenValues.join('');

		if (cv === gv && !(cv === prevPriceValues || cv === prevCocoaValues)) {
			if (currentValues[0].indexOf(window.Resources.CURRENCY_SYMBOL) !== -1) {
				applyRefinementsRange('pmin', 'pmax', $('#price-refinement-link'));
			} else {
				applyRefinementsRange('cmin', 'cmax', $('#cocoa-refinement-link'));
			}
		}
	}, 300);
}

module.exports = function () {

	URLQueries = util.getQueryString(location.href);
	initPriceRefinements();
	initCocoaRefinements();

};
